import * as React from 'react'
import { Button } from 'react-bootstrap'

import { AiVariationContextWithRefresh } from './aiVariationTypes'
import ManageAiVariationsModal from './manageAiVariationsModal/ManageAiVariationsModal'

import './ManageAiVariationsButton.scss'
import { useManageAiVariationsButton } from './useManageAiVariationsButton'

const ManageAiVariationsButton: React.FunctionComponent<AiVariationContextWithRefresh & {
	askToSaveFirst: boolean | undefined
}> = (props) => {
	const { modalVisible, showModal, hideModal } = useManageAiVariationsButton(props)

	return (
		<>
			<div className="ManageAiVariationsButton">
				{props.askToSaveFirst && (
					<>
						Please save your changes
						<br />
						before generating AI ad variations
					</>
				)}
				{!props.askToSaveFirst && (
					<>
						<Button
							bsStyle={'primary'}
							bsSize="small"
							style={{
								backgroundColor: '#165C5F',
								borderColor: '#165C5F',
								opacity: props.askToSaveFirst ? 0.5 : 1,
							}}
							onClick={showModal}
						>
							Generate AI Ads (BETA)
						</Button>
					</>
				)}
			</div>
			{modalVisible && (
				<ManageAiVariationsModal
					campaignId={props.campaignId}
					adGroupNumber={props.adGroupNumber}
					adGroupId={props.adGroupId}
					advertiserName={props.advertiserName}
					hideModal={hideModal}
					adFormat={props.adFormat}
				/>
			)}
		</>
	)
}

export default ManageAiVariationsButton
